// src/components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import authStore from "../utils/authStorage";

// Helper: check JWT expiry
const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const now = Date.now() / 1000;
    return payload.exp < now;
  } catch {
    return true;
  }
};

export default function ProtectedRoute({ children, requireRole }) {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("userRole");

  if (!token || isTokenExpired(token)) {
    authStore.clearAll();
    alert("⏰ Session timed out. Please log in again.");
    return <Navigate to="/login" replace />;
  }

  if (requireRole !== undefined && String(role) !== String(requireRole)) {
    authStore.clearAll();
    return <Navigate to="/login" replace />;
  }

  return children;
}
